import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 16 18">
    <title>Lock</title>
    <path
      d="M8.84375 13.5C8.84375 13.9676 8.46758 14.3438 8 14.3438C7.53242 14.3438 7.15625 13.9676 7.15625 13.5V11.25C7.15625 10.7824 7.53242 10.4062 8 10.4062C8.46758 10.4062 8.84375 10.7824 8.84375 11.25V13.5ZM8 0C10.4855 0 12.5 2.0148 12.5 4.5V6.75H13.625C14.866 6.75 15.875 7.75898 15.875 9V15.75C15.875 16.991 14.866 18 13.625 18H2.375C1.13223 18 0.125 16.991 0.125 15.75V9C0.125 7.75898 1.13223 6.75 2.375 6.75H3.5V4.5C3.5 2.0148 5.51445 0 8 0ZM8 1.6875C6.44609 1.6875 5.1875 2.9468 5.1875 4.5V6.75H10.8125V4.5C10.8125 2.9468 9.55391 1.6875 8 1.6875ZM2.375 8.4375C2.06422 8.4375 1.8125 8.69063 1.8125 9V15.75C1.8125 16.0594 2.06422 16.3125 2.375 16.3125H13.625C13.9344 16.3125 14.1875 16.0594 14.1875 15.75V9C14.1875 8.69063 13.9344 8.4375 13.625 8.4375H2.375Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default Icon;
